module.exports = __webpack_public_path__ + "src/assets/img/engine_six.f96560d0.svg";